export default "__VITE_ASSET__Ip1wIFzU__ 1034w, __VITE_ASSET__BjQw_yxe__ 767w, __VITE_ASSET__dMPDq1uD__ 500w";